import Vue from "vue";
import { Carousel, CarouselItem, Dropdown, DropdownMenu, DropdownItem, Autocomplete, Image, Loading, Pagination } from "element-ui";
Vue
    .use(Pagination)
    .use(Loading.directive)
    .use(Image)
    .use(Autocomplete)
    .use(Carousel)
    .use(CarouselItem)
    .use(Dropdown)
    .use(DropdownMenu)
    .use(DropdownItem);